<script lang="ts">
    import MedialibImage from "../MedialibImage.svelte"

    export let member: TeamEntry
</script>

<article class="team-card col-grid vp-l">
    <figure class="smooth-shadow border-radius-all border-radius-m">
        <div class="background-image">
            <MedialibImage id="{member.image}" />
        </div>
        <figcaption class="h3 tp-m">{member.name}</figcaption>
        <div class="position bp-m">{member.position}</div>
    </figure>
</article>
